import React, { useState, useEffect } from 'react';
import './CookiesBanner.scss'; 

const CookieBanner: React.FC = () => {
  const [showBanner, setShowBanner] = useState<boolean>(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAcceptAll = (): void => {
    localStorage.setItem('cookieConsent', 'all');
    setShowBanner(false);
  };

  const handleManagePreferences = (): void => {
      const userAgent = navigator.userAgent;

      if (userAgent.includes("Chrome")) {
        window.open("https://support.google.com/chrome/answer/95647", "_blank");
      } else if (userAgent.includes("Firefox")) {
        window.open("https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web", "_blank");
      } else if (userAgent.includes("Edg")) {
        window.open("https://support.microsoft.com/es-es/microsoft-edge", "_blank");
      } else {
        alert("No pudimos detectar tu navegador. Buscá en la configuración de privacidad para administrar cookies.");
      }
  } 

  const handleClose = (): void => {
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="gdpr_banner" role="dialog" aria-modal="true">
      <button type="button" className="gdpr_close" onClick={handleClose}>
        <span className="material-symbols-outlined">close</span>
      </button>
      <div className="gdpr_content">
        <h3>Sus preferencias de cookies</h3>
        <p>
          Este sitio utiliza cookies, algunas de las cuales son esenciales para
          su funcionamiento. También tenemos algunas cookies que nos permiten
          medir el tráfico de este sitio web y mostrar anuncios personalizados
          en función de su actividad de navegación, además de permitirle
          compartir contenido en redes sociales.
        </p>
        <p>
          Al hacer clic en “Aceptar todas las cookies”, usted da su
          consentimiento a Fiserv y a sus socios para el uso de cookies. Puede
          cambiar sus preferencias de cookies y ver una lista de nuestros socios
          y afiliados en cualquier momento haciendo clic en “Administrar
          preferencias” o en el botón “Consentimiento de cookies” en la parte
          inferior de esta página.
        </p>
        <p>
          Lea nuestro Aviso de Cookies para obtener detalles sobre el uso de
          cookies y la información que recopilamos.
        </p>
        <div className="gdpr_action">
          <button type="button" className="gdpr_action-confirm" onClick={handleAcceptAll}>
            Aceptar todas las cookies
          </button>
          <button type="button" className="gdpr_action-manage" onClick={handleManagePreferences}>
            Administrar preferencias
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
